import * as zod from 'zod';

export const ActuateScrewdriverVariables = zod.object({});
export type ActuateScrewdriverVariables = zod.infer<
  typeof ActuateScrewdriverVariables
>;
